import React, { Component } from "react";
import { Field } from "formik";
import "./Marketing.scss";
import CustomIntlTelInput from "./CustomIntlTelInput";
import { currentLocale } from "../locale";
import { validateEmail } from "./validation";
import { Checkbox } from "./Checkbox";

class Marketing extends Component {
  state = {
    stateParticipantData: {
      phoneNumber: "", //+447795214092
      email: "",
      icePhoneNumber: "",
      role: 1, //isParticipant - already entered (its own tab)
      optIn: false //must be true in order to end up on this page
    }
  };

  render() {
    const { values, errors, touched, waiver } = this.props;

      let preferredCountries = ["us", "gb", "ca"];
      const locale = window.navigator.language;
      if (locale && locale.length === 5) {
          const country = locale.substring(3);
          if (preferredCountries.indexOf(country) == -1) {
              preferredCountries.unshift(country);
          }
      }
    return (
      <div className="collect-marketing-information">
        {waiver.contactInformation && waiver.iceNumber ? (
          <div>
            <div className="field">
              <label className="label">{currentLocale.enterEmail}:</label>
              <Field
                className="control input"
                validate={validateEmail}
                name="email"
                type="email"
                placeholder={currentLocale.email}
              />
              {errors.email && touched.email ? (
                <span className="validation-message">{errors.email}</span>
              ) : null}
            </div>

            <div className="field">
              <label className="label">{currentLocale.enterPhone}:</label>
              <Field
                name="phoneNumber"
                validate={phoneNumber =>
                  window.intlTelInputUtils.isValidNumber(phoneNumber, "")
                    ? ""
                    : `${currentLocale.phoneNumberError}`
                }
                component={CustomIntlTelInput}
                value={values.phoneNumber}
                preferredCountries={preferredCountries}
                css="input"
              />
            </div>
            <div className="field">
              <label className="label">{currentLocale.enterIce}:</label>
              <Field
                name="icePhoneNumber"
                validate={phoneNumber =>
                  window.intlTelInputUtils.isValidNumber(phoneNumber, "")
                    ? ""
                    : `${currentLocale.phoneNumberError}`
                }
                value={values.icePhoneNumber}
                component={CustomIntlTelInput}
                preferredCountries={preferredCountries}
                css="input"
              />
            </div>
            <div>
              <Field
                className="checkbox"
                component={Checkbox}
                name="optIn"
                label={currentLocale.optInHeading}
                value={values.optIn}
              />
            </div>
          </div>
        ) : waiver.contactInformation ? (
          <div>
            <div className="field">
              <label className="label">{currentLocale.enterEmail}:</label>
              <Field
                className="control input"
                validate={validateEmail}
                name="email"
                type="email"
                placeholder={currentLocale.email}
              />
              {errors.email && touched.email ? (
                <span className="validation-message">{errors.email}</span>
              ) : null}
            </div>

            <div className="field">
              <label className="label">{currentLocale.enterPhone}:</label>
              <Field
                name="phoneNumber"
                validate={phoneNumber =>
                  window.intlTelInputUtils.isValidNumber(phoneNumber, "")
                    ? ""
                    : `${currentLocale.phoneNumberError}`
                }
                component={CustomIntlTelInput}
                value={values.phoneNumber}
                preferredCountries={preferredCountries}
                css="input"
              />
            </div>

            <div>
              <Field
                className="checkbox"
                component={Checkbox}
                name="optIn"
                label={currentLocale.optInHeading}
                value={values.optIn}
              />
            </div>
          </div>
        ) : waiver.iceNumber ? (
          <div>
            <div className="field">
              <label className="label">{currentLocale.enterIce}:</label>
              <Field
                validate={phoneNumber =>
                  window.intlTelInputUtils.isValidNumber(phoneNumber, "")
                    ? ""
                    : `${currentLocale.phoneNumberError}`
                }
                name="icePhoneNumber"
                component={CustomIntlTelInput}
                value={values.icePhoneNumber}
                preferredCountries={preferredCountries}
                css="input"
              />
            </div>
          </div>
        ) : (
          <div>
            <h1>{currentLocale.loading}</h1>
          </div>
        )}
      </div>
    );
  }
}

export default Marketing;
